import React, { useState, useEffect } from "react";
import { CardBody } from "shards-react";
import * as status from './SelectList/Status';
import ReactTable from "react-table";

const SummaryPartners = ({ countByPartner }) => {
    const [statusByPartners, setStatusByPartners] = useState([]);

    useEffect(() => {
        const partnerRow = [];
        const totalByColumns = {};

        Object.keys(countByPartner).forEach(name => {
            const statusRow = {
                ...countByPartner[name],
                partners: name,
            };

            Object.keys(countByPartner[name]).forEach((columnName) => {
                totalByColumns[columnName] = (totalByColumns[columnName] || 0) + countByPartner[name][columnName];
            });
            partnerRow.push(statusRow);
        });

        const totalRow = {
            partners: 'Total',
            ...totalByColumns,
        };

        setStatusByPartners([...partnerRow, totalRow]);
    }, [countByPartner]);

    const columns = [
        {
            Header: 'Partenaires',
            accessor: 'partners',
        },
    ];

    const statusSearch = status.list();
    statusSearch.forEach((status) => {
        const { value, label } = status;
        columns.push({
            Header: label,
            accessor: value,
            Cell: row => <span style={{ fontWeight: row.value > 0 ? 'bold' : 'normal' }}> { row.value } </span>,
            minWidth: 180,
        });
    });

    return (
        <div>
            <h1 className="ml-3"> Total </h1>
            <CardBody>
                <ReactTable
                    style = {{ width: '100%' }}
                    showHeader = { false }
                    data = { statusByPartners }
                    columns = { columns }
                    minRows = { 1 }
                    getTdProps = { () => ({ style: { whiteSpace: 'unset' } }) }
                    showPageSizeOptions = { false }
                    resizable = { false }
                    previousText = 'Précédent'
                    nextText = 'Suivant'
                    noDataText = 'Pas de données trouvées'
                    ofText = 'sur'
                    sortable = { true }
                    filterable = { false }
                />
            </CardBody>
        </div>
    );
};

export default SummaryPartners;



// WEBPACK FOOTER //
// ./src/views/Dashboardlive/SummaryPartners.js